import React from 'react';
import { Grid } from '@mui/material';

const PoolsTitleBarLayout = ({ children }) => (
    <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        sx={{
            backgroundColor: 'white',
            borderRadius: 1,
            paddingX: 2,
            paddingY: 2,
            borderBottom: '1px solid lightgrey'
        }}
    >
        {children}
    </Grid>
);

export default PoolsTitleBarLayout;
